jQuery(document).ready(function() {
  // tabbing for menu overlay
	$("#tabs").tabs({
		collapsible: false,
		show: 'fade',
		hide: 'fade'
	});
});